module.exports = __webpack_public_path__ + "static/media/share.3a02f2fe.svg";